// W2 Dashboard: the module contract (features/README.md). Exports exactly routes, navigation and permissions.
import type { FeatureModule } from '@care-platform/shell';
import { LayoutDashboard } from 'lucide-react';

export const permissions: FeatureModule['permissions'] = ['clients.read'];

export const routes: FeatureModule['routes'] = [
  { id: 'dashboard.home', path: '', load: () => import('./dashboard-page') },
];

export const navigation: FeatureModule['navigation'] = [
  {
    id: 'dashboard',
    routeId: 'dashboard.home',
    label: (copy) => copy.nav.dashboard,
    icon: LayoutDashboard,
    pillar: 'clinical',
    permission: 'clients.read',
    order: 10,
  },
];
